var h = Object.freeze, v = Object.defineProperty;
var r = (o, e) => h(v(o, "raw", { value: h(e || o.slice()) }));
import { L as w } from "./lds-element-4P-EWHZh.js";
import { i as C, x as I } from "./lit-element-CwWchyls.js";
import { n as $ } from "./property-EvzlnPW3.js";
import { r as b } from "./state-D88UmDIj.js";
import { i as x, o as m, c as E } from "./config-CYJMII9C.js";
var f;
const y = C(f || (f = r(["\n    :host {\n        display: inline-flex;\n        flex-shrink: 0;\n        width: 1em;\n        height: 1em;\n    }\n\n    svg {\n        height: 100%;\n        width: 100%;\n        overflow: visible;\n        fill: currentColor;\n    }\n"])));
var O = Object.defineProperty, p = (o, e, t, s) => {
  for (var i = void 0, c = o.length - 1, d; c >= 0; c--)
    (d = o[c]) && (i = d(e, t, i) || i);
  return i && O(e, t, i), i;
}, n, u;
const l = (n = class extends w {
  constructor() {
    super(...arguments), this.iconContent = "";
  }
  willUpdate(e) {
    e.has("name") && this.loadIcon();
  }
  render() {
    return I(u || (u = r(["", ""])), this.iconContent);
  }
  loadIcon() {
    if (this.name) {
      if (x.indexOf(this.name) === -1) {
        console.warn('lds-icon\nIcon "'.concat(this.name, '" not found.'));
        return;
      }
      if (n.iconCache.has(this.name)) {
        const e = n.iconCache.get(this.name);
        e == null || e.then((t) => {
          this.iconContent = m(t);
        });
      } else {
        const e = fetch("".concat(E.cdnUrl, "/core/v0.19.5/icons/").concat(this.name, ".svg?raw"));
        n.iconCache.set(
          this.name,
          new Promise((t) => {
            e.then((s) => s.text()).then((s) => {
              s.includes("<svg") ? (this.iconContent = m(s), t(s)) : console.warn('lds-icon\nIcon "'.concat(this.name, '" could not be loaded.'));
            }).catch(() => console.warn('lds-icon\nIcon "'.concat(this.name, '" could not be loaded.')));
          })
        );
      }
    }
  }
}, n.styles = y, n.iconCache = /* @__PURE__ */ new Map(), n);
p([
  $()
], l.prototype, "name");
p([
  b()
], l.prototype, "iconContent");
let a = l;
const g = new URL(import.meta.url), N = g.searchParams.has("debug");
if (!g.searchParams.has("no-define")) {
  const o = customElements.get("lds-icon");
  o ? o.VERSION !== a.VERSION && N && console.log("%clds-icon tried loading in version ".concat(a.VERSION, ", but lds-icon is already defined as ").concat(o.VERSION), "font-weight: bold; font-size: 16px; color: red;") : customElements.define("lds-icon", a);
}
export {
  a as LdsIcon
};
